import React, { Component } from 'react';
import { Button } from '@mui/material';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from '../../components/WithRouter';
import { aminoSignTx, initializeChain, initializeLeap, connectAccountSuccess } from '../../actions/account/wallet';
import { connectBCAccount, fetchProfileDetails, setDisconnect, verifyAccount } from '../../actions/account';
import { fetchAllowances, fetchBalance } from '../../actions/account/BCDetails';
import DotsLoading from '../../components/DotsLoading';
import { config, DEFAULT_LIMIT, DEFAULT_SEARCH, DEFAULT_SKIP, defaultThumbnail } from '../../config';
import SidePanel from './SidePanel';
import { fetchIBCTokensList, fetchListings } from '../../actions/createAssets/listing';
import { connectIBCAccount } from '../../actions/account/IBCTokens';
import { fetchIBCBalanceList } from '../../actions/faucet';
import { fetchAssets } from '../../actions/library';
import { fetchAuctions } from '../../actions/auctions';
import { fetchCollections, fetchNftListOwned } from '../../actions/createAssets/mintNft';
// import { getWrapAddress } from '../../utils/strings';
import { initializeCosmoStation } from '../../actions/account/cosmostation';
import { fetchAssetCards } from '../../actions/createAssets';
import ImageOnLoad from '../../components/ImageOnLoad';
import { getProfilePicture } from '../../actions/account/profilePicture';
import { fetchFeatures } from '../../actions/navBar';
import { formatCount } from '../../utils/price';
import para from '../../utils/para';
import { ParaAminoSigner } from '@getpara/cosmjs-v0-integration';

class ProfilePopover extends Component {
    constructor (props) {
        super(props);
        this.state = {
            open: false,
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleReDirect = this.handleReDirect.bind(this);
        this.initializeKeplr = this.initializeKeplr.bind(this);
        this.initKeplr = this.initKeplr.bind(this);
        this.handleKeplrEvent = this.handleKeplrEvent.bind(this);
        this.handleLeapEvent = this.handleLeapEvent.bind(this);
        this.initializePara = this.initializePara.bind(this);
    }

    componentDidMount () {
        if (this.props.address === '' && localStorage.getItem('address_of_studio')) {
            if (localStorage.getItem('studio_cosmostation')) {
                setTimeout(() => {
                    this.initializeCosmoStation();
                }, 600);

                return;
            }
            if (localStorage.getItem('studio_leap')) {
                setTimeout(() => {
                    this.initializeLeap();
                }, 600);

                return;
            }

            if (localStorage.getItem('studio_para')) {
                setTimeout(() => {
                    this.initializePara();
                }, 600);

                return;
            }

            setTimeout(() => {
                this.initializeKeplr();
            }, 600);
        } else {
            if ((this.props.address) &&
                (this.props.balance.length === 0) && !this.props.balanceInProgress) {
                this.props.fetchBalance(this.props.address);
            }
            if (this.props.address && this.props.allowances &&
                (this.props.allowances.length === 0) && !this.props.allowancesInProgress) {
                this.props.fetchAllowances(this.props.address);
            }

            if (this.props.address) {
                this.props.getProfilePicture(this.props.address);
            }
        }

        if (!Object.keys(this.props.profileDetails).length && !this.props.profileDetailsInProgress) {
            this.props.fetchProfileDetails();
        }
        if ((this.props.featuresData && this.props.featuresData.length === 0) && !this.props.featuresInProgress) {
            this.props.fetchFeatures();
        }
        if (this.props.ibcTokensList.length === 0 && !this.props.ibcTokensListInProgress) {
            this.props.fetchIBCTokensList();
        }

        if (localStorage.getItem('studio_cosmostation')) {
            window.cosmostation.cosmos.on('accountChanged', () => {
                this.props.setDisconnect();
                this.initCosmoStation();
                localStorage.removeItem('acToken_of_studio');
                localStorage.removeItem('address_of_studio');
                Object.keys(localStorage).forEach((key) => {
                    if (key.startsWith('acToken_of_studio_media_node') || key.startsWith('rfToken_of_studio_media_node') ||
                    key.startsWith('active_of_studio_media_node') || key.startsWith('active_of_studio_media_node_id') ||
                    key.startsWith('connected_media_nodes')) {
                        localStorage.removeItem(key);
                    }
                });
            });
        } else if (localStorage.getItem('studio_leap')) {
            window.addEventListener('leap_keystorechange', this.handleLeapEvent);
        } else {
            window.addEventListener('keplr_keystorechange', this.handleKeplrEvent);
        }
    }

    componentDidUpdate (pp, ps, ss) {
        const path = this.props.router && this.props.router.location && this.props.router.location.pathname && this.props.router.location.pathname.split('/');
        if (this.props.auth && (pp.auth !== this.props.auth) && !this.props.profileDetailsInProgress) {
            this.props.fetchProfileDetails();
        }
        if (this.props.address && !this.props.inProgress && pp.address !== this.props.address) {
            this.props.getProfilePicture(this.props.address);
        }
        if (path && path.length > 0 && path[1] !== 'library') {
            if (this.props.auth && (pp.auth !== this.props.auth) && !this.props.statsInProgress) {
                setTimeout(() => {
                    this.props.fetchAssetCards();
                }, 400);
            }
            if (this.props.auth && (pp.auth !== this.props.auth) && this.props.nftListOwned &&
                this.props.nftListOwned.length && !this.props.nftListOwnedInProgress) {
                setTimeout(() => {
                    this.props.fetchNftListOwned(this.props.address, DEFAULT_SKIP, DEFAULT_LIMIT, DEFAULT_SEARCH);
                }, 400);
            }
            if (this.props.auth && (pp.auth !== this.props.auth) && this.props.collection &&
                this.props.collection.length && !this.props.collectionInProgress) {
                setTimeout(() => {
                    this.props.fetchCollections(this.props.address, DEFAULT_SKIP, DEFAULT_LIMIT, DEFAULT_SEARCH);
                }, 400);
            }
            if (this.props.auth && (pp.auth !== this.props.auth) && this.props.listings &&
                this.props.listings.length && !this.props.listingsInProgress) {
                setTimeout(() => {
                    this.props.fetchListings(this.props.address, DEFAULT_SKIP, DEFAULT_LIMIT, DEFAULT_SEARCH);
                }, 400);
            }
            if (this.props.auth && (pp.auth !== this.props.auth) && this.props.auctions &&
                this.props.auctions.length && !this.props.auctionsInProgress) {
                setTimeout(() => {
                    this.props.fetchAuctions(this.props.address, DEFAULT_SKIP, DEFAULT_LIMIT, DEFAULT_SEARCH);
                }, 400);
            }
        }
    }

    componentWillUnmount () {
        window.removeEventListener('keplr_keystorechange', this.handleKeplrEvent);
        window.removeEventListener('leap_keystorechange', this.handleLeapEvent);
    }

    handleKeplrEvent () {
        this.props.setDisconnect();
        if (localStorage.getItem('acToken_of_studio')) {
            this.initKeplr();
        }
        localStorage.removeItem('acToken_of_studio');
        localStorage.removeItem('address_of_studio');
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith('acToken_of_studio_media_node') || key.startsWith('rfToken_of_studio_media_node') ||
            key.startsWith('active_of_studio_media_node') || key.startsWith('active_of_studio_media_node_id') ||
            key.startsWith('connected_media_nodes')) {
                localStorage.removeItem(key);
            }
        });
    }

    initKeplr () {
        this.props.initializeChain((address) => {
            if (address.length && address[0] && address[0].address) {
                const data = {
                    bcAccountAddress: address[0].address,
                };
                this.props.connectBCAccount(data, (res) => {
                    if (res) {
                        if (window.keplr) {
                            window.keplr.defaultOptions = {
                                sign: {
                                    preferNoSetFee: true,
                                    preferNoSetMemo: true,
                                },
                            };
                        }
                        const tx = {
                            msg: {
                                type: 'omniflix/MsgSign',
                                value: {
                                    address: address[0].address,
                                },
                            },
                            fee: {
                                amount: [{
                                    amount: String(0),
                                    denom: config.COIN_MINIMAL_DENOM,
                                }],
                                gas: String(1),
                            },
                            memo: res['auth_code'],
                        };

                        this.props.aminoSignTx(tx, address[0].address, (result) => {
                            if (result) {
                                const data = {
                                    authCode: res['auth_code'],
                                    sign: result.signature,
                                };

                                this.props.verifyAccount(res._id, data, (error) => {
                                    if (!error) {
                                        localStorage.setItem('address_of_studio', address[0].address);
                                        this.props.fetchBalance(address[0].address);
                                        this.props.fetchAllowances(address[0].address);
                                        this.props.fetchProfileDetails();
                                        if (window.keplr) {
                                            window.keplr.defaultOptions = {};
                                        }
                                    }
                                });
                            } else {
                                this.handleReDirect('/');
                            }
                        });
                    }
                });
            }
        });
    }

    initializeKeplr () {
        this.props.initializeChain((address) => {
            if (!address) {
                window.onload = () => this.initializeKeplr();
                return;
            }

            if ((address && address.length && address[0] && address[0].address) &&
                (this.props.balance.length === 0) && !this.props.balanceInProgress) {
                this.props.fetchBalance(address[0].address);
            }
            if ((address && address.length && address[0] && address[0].address) &&
                this.props.allowances && (this.props.allowances.length === 0) && !this.props.allowancesInProgress) {
                this.props.fetchAllowances(address[0].address);
            }
        });
    }

    initCosmoStation () {
        this.props.initializeCosmoStation((error, account) => {
            if (error) {
                return;
            }

            localStorage.setItem('address_of_studio', account && account.address);
            this.props.fetchBalance(account.address);
            this.props.fetchAllowances(account.address);
        });
    }

    initializeCosmoStation () {
        this.props.initializeCosmoStation((error, account) => {
            if (error) {
                return;
            }

            if (!account) {
                window.onload = () => this.initializeCosmoStation();
                return;
            }

            localStorage.setItem('address_of_studio', account && account.address);
            if ((account && account.address) &&
                (this.props.balance.length === 0) && !this.props.balanceInProgress) {
                this.props.fetchBalance(account.address);
            }
            if ((account && account.address) &&
                this.props.allowances && (this.props.allowances.length === 0) && !this.props.allowancesInProgress) {
                this.props.fetchAllowances(account.address);
            }
        });
    }

    handleLeapEvent () {
        this.props.setDisconnect();
        this.initLeap();
        localStorage.removeItem('acToken_of_studio');
        localStorage.removeItem('address_of_studio');
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith('acToken_of_studio_media_node') || key.startsWith('rfToken_of_studio_media_node') ||
            key.startsWith('active_of_studio_media_node') || key.startsWith('active_of_studio_media_node_id') ||
            key.startsWith('connected_media_nodes')) {
                localStorage.removeItem(key);
            }
        });
    }

    initLeap () {
        this.props.initializeLeap((address) => {
            localStorage.setItem('address_of_studio', address && address.length && address[0] && address[0].address);
            this.props.fetchBalance(address[0].address);
            this.props.fetchAllowances(address[0].address);
        });
    }

    initializeLeap () {
        this.props.initializeLeap((address) => {
            if (!address) {
                window.onload = () => this.initializeLeap();
                return;
            }

            localStorage.setItem('address_of_studio', address && address.length && address[0] && address[0].address);
            if ((address && address.length && address[0] && address[0].address) &&
                (this.props.balance.length === 0) && !this.props.balanceInProgress) {
                this.props.fetchBalance(address[0].address);
            }
            if ((address && address.length && address[0] && address[0].address) &&
                this.props.allowances && (this.props.allowances.length === 0) && !this.props.allowancesInProgress) {
                this.props.fetchAllowances(address[0].address);
            }
            localStorage.setItem('studio_leap', 'leap');
        });
    }

    initializePara () {
        if (para) {
            para.isFullyLoggedIn().then((res) => {
                if (res) {
                    const aminoSigner = new ParaAminoSigner(para, config?.PREFIX || 'omniflix');
                    const address = aminoSigner.address;
                    this.props.connectAccountSuccess([{ address: address }]);
                    localStorage.setItem('address_of_studio', address);
                    if (address && this.props.balance.length === 0 && !this.props.balanceInProgress) {
                        this.props.fetchBalance(address);
                    }
                    if (address && this.props.allowances && this.props.allowances.length === 0 && !this.props.allowancesInProgress) {
                        this.props.fetchAllowances(address);
                    }
                    localStorage.setItem('studio_para', 'para');
                } else {
                    this.handleDisconnect();
                }
            }).catch((error) => {
                console.error('Error checking login status:', error);
            });
        }
    }

    handleOpen () {
        this.setState({
            open: true,
        });
        this.props.handleOverlay(false);
    }

    handleClose () {
        this.setState({
            open: false,
        });
    }

    handleReDirect (path) {
        this.props.router.navigate(path);
        this.handleClose();

        if (path === '/') {
            this.props.setDisconnect();
            localStorage.removeItem('acToken_of_studio');
            localStorage.removeItem('rfToken_of_studio');
            localStorage.removeItem('address_of_studio');
        }
    }

    render () {
        // const { address } = this.props;
        const balance = this.props.balance && this.props.balance.length && this.props.balance.find((val) => val.denom === config.COIN_MINIMAL_DENOM);
        const userName = this.props.userName;
        const userUrl = this.props.profilePicture?.profile_image;
        const userCdnUrl = this.props.profilePicture?.profile_image_cdn?.variants;

        return (
            <div className="profile">
                <Button aria-label="amount" className="profile_section" variant="contained" onClick={this.handleOpen}>
                    <div className="profile_img">
                        <ImageOnLoad
                            cdn={userCdnUrl}
                            defaultThumbnail={defaultThumbnail.CHANNEL}
                            src={userUrl}/>
                    </div>
                    {this.props.inProgress || this.props.balanceInProgress
                        ? <DotsLoading/>
                        : balance && balance.amount
                            ? `${formatCount(balance.amount / (10 ** config.COIN_DECIMALS), true)} ${config.COIN_DENOM}`
                            : `0 ${config.COIN_DENOM}`}
                </Button>
                <SidePanel name={userName} open={this.state.open} onClose={this.handleClose}/>
            </div>
        );
    }
}

ProfilePopover.propTypes = {
    address: PropTypes.string.isRequired,
    allowances: PropTypes.array.isRequired,
    allowancesInProgress: PropTypes.bool.isRequired,
    aminoSignTx: PropTypes.func.isRequired,
    assets: PropTypes.array.isRequired,
    assetsInProgress: PropTypes.bool.isRequired,
    auctions: PropTypes.array.isRequired,
    auctionsInProgress: PropTypes.bool.isRequired,
    balance: PropTypes.array.isRequired,
    balanceInProgress: PropTypes.bool.isRequired,
    collection: PropTypes.array.isRequired,
    collectionInProgress: PropTypes.bool.isRequired,
    connectAccountSuccess: PropTypes.func.isRequired,
    connectBCAccount: PropTypes.func.isRequired,
    connectIBCAccount: PropTypes.func.isRequired,
    featuresData: PropTypes.array.isRequired,
    featuresInProgress: PropTypes.bool.isRequired,
    fetchAllowances: PropTypes.func.isRequired,
    fetchAssetCards: PropTypes.func.isRequired,
    fetchAssets: PropTypes.func.isRequired,
    fetchAuctions: PropTypes.func.isRequired,
    fetchBalance: PropTypes.func.isRequired,
    fetchCollections: PropTypes.func.isRequired,
    fetchFeatures: PropTypes.func.isRequired,
    fetchIBCBalanceList: PropTypes.func.isRequired,
    fetchIBCTokensList: PropTypes.func.isRequired,
    fetchListings: PropTypes.func.isRequired,
    fetchNftListOwned: PropTypes.func.isRequired,
    fetchProfileDetails: PropTypes.func.isRequired,
    handleOverlay: PropTypes.func.isRequired,
    ibcTokensList: PropTypes.array.isRequired,
    ibcTokensListInProgress: PropTypes.bool.isRequired,
    inProgress: PropTypes.bool.isRequired,
    initializeChain: PropTypes.func.isRequired,
    initializeCosmoStation: PropTypes.func.isRequired,
    initializeLeap: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    nftListOwned: PropTypes.array.isRequired,
    nftListOwnedInProgress: PropTypes.bool.isRequired,
    profileDetails: PropTypes.object.isRequired,
    profileDetailsInProgress: PropTypes.bool.isRequired,
    setDisconnect: PropTypes.func.isRequired,
    statsInProgress: PropTypes.bool.isRequired,
    userName: PropTypes.string.isRequired,
    verifyAccount: PropTypes.func.isRequired,
    auth: PropTypes.string,
    getProfilePicture: PropTypes.func,
    listings: PropTypes.array,
    listingsInProgress: PropTypes.bool,
    profilePicture: PropTypes.array,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }).isRequired,
    }),
};

const stateToProps = (state) => {
    return {
        address: state.account.connection.address,
        auth: state.account.token.value,
        allowances: state.account.bc.allowances.value,
        allowancesInProgress: state.account.bc.allowances.inProgress,
        balance: state.account.bc.balance.value,
        balanceInProgress: state.account.bc.balance.inProgress,
        inProgress: state.account.connection.addressInProgress,
        lang: state.language,
        profileDetails: state.account.profileDetails.value,
        profileDetailsInProgress: state.account.profileDetails.inProgress,
        userName: state.account.bc.userName,
        ibcTokensList: state.createAssets.listing.ibcTokensList.value,
        ibcTokensListInProgress: state.createAssets.listing.ibcTokensList.inProgress,

        assets: state.library.assets.value,
        assetsInProgress: state.library.assets.inProgress,

        auctions: state.auctions.list.value,
        auctionsInProgress: state.auctions.list.inProgress,

        collection: state.createAssets.nft.collection.options,
        collectionInProgress: state.createAssets.nft.collection.inProgress,

        nftListOwned: state.createAssets.nft.nftListOwned.value,
        nftListOwnedInProgress: state.createAssets.nft.nftListOwned.inProgress,

        listings: state.createAssets.listing.list.value,
        listingsInProgress: state.createAssets.listing.list.inProgress,

        statsInProgress: state.createAssets.cards.inProgress,

        profilePicture: state.account.profilePicture.getProfilePicture.value,

        featuresInProgress: state.navBar.features.inProgress,
        featuresData: state.navBar.features.list,
    };
};

const actionToProps = {
    aminoSignTx,
    connectBCAccount,
    connectIBCAccount,
    fetchAssets,
    fetchAuctions,
    fetchCollections,
    fetchNftListOwned,
    fetchListings,
    fetchAllowances,
    fetchBalance,
    fetchIBCBalanceList,
    fetchIBCTokensList,
    fetchProfileDetails,
    initializeChain,
    verifyAccount,
    setDisconnect,
    fetchAssetCards,

    initializeCosmoStation,
    initializeLeap,
    getProfilePicture,

    fetchFeatures,
    connectAccountSuccess,
};

export default withRouter(connect(stateToProps, actionToProps)(ProfilePopover));
